<ion-card>
  
  <ion-fab vertical="center" horizontal="end" *ngIf="document.serviceJob.binLocation.locationTag">
      <ion-fab-button *ngIf="document.documentNumber === 0" (click)="openModalSearch()" size="small" color="light">
          <ion-icon name="location"></ion-icon>
      </ion-fab-button>
  </ion-fab>

  <ion-card-content *ngIf="!document.serviceJob.binLocation.locationTag" (click)="openModalSearch()">
    <ion-label>Select Bin Location... </ion-label>
  </ion-card-content>


  <ion-card-content *ngIf="document.serviceJob.binLocation.locationTag" (click)="openModalSearch()">
      <ion-row class="ion-no-padding ion-no-margin">
          <ion-col size="9" class="ion-no-padding ion-no-margin">
            <ion-label position="floating" style="color: black;">Bin Location</ion-label>  
            <p> {{ document.serviceJob.binLocation.locationTag }} </p>
          </ion-col>
      </ion-row>
     
  </ion-card-content>
</ion-card>

